export default "__VITE_ASSET__ciGcp5mk__"